import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable, Subject } from 'rxjs';

import { getHttpHeaders } from '@commons/utility/util';
import { CustomResponseDto } from '@core/model/custom-response-dto';
import { environment } from '@environments/environment';
import { routes } from '@model/constants/routes';
import { CardResponseType } from './models';

@Injectable({
  providedIn: 'root',
})
export class HeaderService {
  private readonly headers = getHttpHeaders();
  private readonly subject = new Subject();
  private readonly apiGatewayUrl: string;

  constructor(private readonly http: HttpClient) {
    this.apiGatewayUrl = environment.apiGatewayUrl;
  }

  public getUserInformation(): Observable<CustomResponseDto<string>> {
    return this.http.get<CustomResponseDto<string>>(this.apiGatewayUrl + routes.getUserInformation, {
      headers: this.headers,
    });
  }

  public showMenu(state: boolean = true) {
    this.subject.next({
      showMenu: state,
    });
  }

  public updateUserInfo() {
    this.subject.next({
      updateUserInfo: true,
    });
  }

  public getMenuControl(): Observable<any> {
    return this.subject.asObservable();
  }

  public activeCard(): Observable<CardResponseType> {
    return this.http.get<CardResponseType>(this.apiGatewayUrl + routes.activeCard, { headers: this.headers });
  }

  public updateCardStatus(cardId: string, status: string): Observable<unknown> {
    const url = `${this.apiGatewayUrl}${routes.updateCardStatus}`;
    const body = { cardId, status, reason: 'USER_INTERNAL_REASON' };
    return this.http.patch(url, body, { headers: this.headers });
  }
}
